import styles from './style.module.scss';
import { Element } from 'react-scroll';
import { useUserAgentInfo } from '../../../context/user-agent';
import { useRef, useState } from 'react';
import FadeIn from '../../commonComponents/fadeIn';
import MobileTab from '/components/solutionPageComponent/mobileTab';
import CollapseList from '@/components/commonComponents/collapseList';

const UseCase = ({
  elementName,
  useCaseData,
  couldCloseAll = false, //couldCloseAll? 是否可以折叠全部选项 默认 false
}) => {
  const [currentOpenIndex, setCurrentOpenIndex] = useState(0);
  const { isMobile } = useUserAgentInfo();

  return (
    <Element name={elementName}>
      <FadeIn>
        {isMobile ? (
          <main className={styles['mobile-display']}>
            <MobileTab useCaseData={useCaseData} />
          </main>
        ) : (
          <main className={styles.container}>
            <div className={styles.title}>{useCaseData.title}</div>
            <CollapseList
              couldCloseAll={couldCloseAll}
              active={currentOpenIndex}
              setActive={setCurrentOpenIndex}
              list={useCaseData.items}
            />
          </main>
        )}
      </FadeIn>
    </Element>
  );
};

export default UseCase;
